(function () {
  var result = [document.visibilityState !== "visible" ? 1 : 0, navigator.webdriver ? 1 : 0];
  document.cookie = "robot-check=" + result.join("_");
})();
